import {
  FETCH_TRAINER_REFLECTION_SURVEY_SUCCESS,
  FETCH_TRAINER_REFLECTION_SURVEY_FAIL,
  TRAINER_REFLECTION_EXISTS,
  SUBMIT_TRAINER_REFLECTION_START,
  SUBMIT_TRAINER_REFLECTION_SUCCESS,
  SUBMIT_TRAINER_REFLECTION_FAIL,
  RESET_TRAINER_REFLECTION
} from '../constants/actionTypes';

export const DEFAULT_SUBMIT_ERROR =
  'Something went wrong submitting your feedback. Please try again.';

const isActiveSubmitResponse = (state, payload) =>
  state.submitting &&
  payload &&
  payload.sessionId === state.submittingSessionId;

const initialState = {
  questions: [],
  loaded: false,
  submitting: false,
  submittingSessionId: null,
  submitted: false,
  existingResponse: null,
  submitError: ''
};

const trainerReflection = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_TRAINER_REFLECTION_SURVEY_SUCCESS:
      return {
        ...state,
        questions: (payload && payload.questionsForSurvey) || [],
        loaded: true
      };

    case FETCH_TRAINER_REFLECTION_SURVEY_FAIL:
      return {
        ...state,
        questions: [],
        loaded: true
      };

    case TRAINER_REFLECTION_EXISTS:
      return {
        ...state,
        existingResponse: payload,
        loaded: true
      };

    case SUBMIT_TRAINER_REFLECTION_START:
      return {
        ...state,
        submitting: true,
        submittingSessionId: payload && payload.sessionId,
        submitError: ''
      };

    case SUBMIT_TRAINER_REFLECTION_SUCCESS:
      if (!isActiveSubmitResponse(state, payload)) {
        return state;
      }
      return {
        ...state,
        submitting: false,
        submitted: true,
        submitError: ''
      };

    case SUBMIT_TRAINER_REFLECTION_FAIL: {
      if (!isActiveSubmitResponse(state, payload)) {
        return state;
      }

      const isClientError = payload.status >= 400 && payload.status < 500;

      return {
        ...state,
        submitting: false,
        submitError: (isClientError && payload.message) || DEFAULT_SUBMIT_ERROR
      };
    }

    case RESET_TRAINER_REFLECTION:
      return initialState;

    default:
      return state;
  }
};

export default trainerReflection;
